export const houseTypeLibrary = {
    collectHouseType: '收藏户型',
    hot: '热门楼盘',
    noData: '暂无收藏',
    freeMemberTip:
        '在免费试用版中，您只能使用10次3D户型开始设计，可通过升级会员解锁更多专属权益',
    baseQuarterMemberTip:
        '您已开通基础会员，能免费使用40次3D户型开始设计，可通过升级会员解锁更多专属权益',
    baseMemberTip:
        '您已开通基础会员，能免费使用150次3D户型开始设计，可通过升级会员解锁更多专属权益',
    goUpgrade: '前往升级>',
    emptyMessage: '所选位置暂无数据，已为您切换到福州市',
    collect: '收藏',
    cancelCollect: '取消收藏户型',
    toCollect: '去收藏',
    collected: '已收藏',
    collectSuccess: '收藏户型成功',
    drawing: '平台绘制中',
};
